export const CPF_DIGITS = 11;
export const DOCUMENT_MAX_DIGITS = 14;
export const PHONE_MAX_DIGITS = 11;

const LANDLINE_PHONE_DIGITS = 10;
const AREA_CODE_DIGITS = 2;

export const onlyDigits = value => String(value ?? "").replace(/\D/g, "");

// Splits digits into consecutive groups and joins them with the separator that precedes each group.
const applyGroups = (digits, groups) => {
  let result = "";
  let position = 0;

  for (const { size, prefix } of groups) {
    const chunk = digits.slice(position, position + size);
    if (!chunk) break;

    result += (position ? prefix : "") + chunk;
    position += size;
  }

  return result;
};

const CPF_GROUPS = [
  { size: 3 },
  { size: 3, prefix: "." },
  { size: 3, prefix: "." },
  { size: 2, prefix: "-" },
];

const CNPJ_GROUPS = [
  { size: 2 },
  { size: 3, prefix: "." },
  { size: 3, prefix: "." },
  { size: 4, prefix: "/" },
  { size: 2, prefix: "-" },
];

export const formatDocument = value => {
  const digits = onlyDigits(value).slice(0, DOCUMENT_MAX_DIGITS);

  return applyGroups(
    digits,
    digits.length > CPF_DIGITS ? CNPJ_GROUPS : CPF_GROUPS,
  );
};

export const formatPhone = value => {
  const digits = onlyDigits(value).slice(0, PHONE_MAX_DIGITS);
  if (!digits) return "";

  const areaCode = digits.slice(0, AREA_CODE_DIGITS);
  const number = digits.slice(AREA_CODE_DIGITS);
  if (!number) return `(${areaCode}`;

  const firstPartSize = digits.length > LANDLINE_PHONE_DIGITS ? 5 : 4;
  const firstPart = number.slice(0, firstPartSize);
  const lastPart = number.slice(firstPartSize);

  return `(${areaCode}) ${firstPart}${lastPart ? `-${lastPart}` : ""}`;
};
